/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
// CUSTOM-START: cl-cart-01
import { loadData as CartPageLoader } from './CartPage/CartPage.duck';
import { loadData as CartCheckoutPageLoader } from './CartCheckoutPage/CartCheckoutPage.duck';
// CUSTOM-END: cl-cart-01
// CUSTOM-START: cl-neg-01
import { loadData as BuyerOfferPageLoader } from './BuyerOfferPage/BuyerOfferPage.duck';
import { loadData as OfferCheckoutPageLoader } from './OfferCheckoutPage/OfferCheckoutPage.duck';
// CUSTOM-END: cl-neg-01
// CUSTOM-START: stock-locations
import { loadData as StockLocationsPageLoader } from './StockLocationsPage/StockLocationsPage.duck';
// CUSTOM-END: stock-locations
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as MakeOfferPageLoader } from './MakeOfferPage/MakeOfferPage.duck';
import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as RequestQuotePageLoader } from './RequestQuotePage/RequestQuotePage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';

const getPageDataLoadingAPI = () => {
  return {
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    // CUSTOM-START: cl-cart-01
    // Resolves immediately: the cart lives in browser storage, so the server cannot know
    // what is in it. The listings are fetched client-side once the cart has initialised.
    CartPage: {
      loadData: CartPageLoader,
    },
    CartCheckoutPage: {
      loadData: CartCheckoutPageLoader,
    },
    // CUSTOM-END: cl-cart-01
    // CUSTOM-START: cl-neg-01
    BuyerOfferPage: {
      loadData: BuyerOfferPageLoader,
    },
    OfferCheckoutPage: {
      loadData: OfferCheckoutPageLoader,
    },
    // CUSTOM-END: cl-neg-01
    // CUSTOM-START: stock-locations
    StockLocationsPage: {
      loadData: StockLocationsPageLoader,
    },
    // CUSTOM-END: stock-locations
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    MakeOfferPage: {
      loadData: MakeOfferPageLoader,
    },
    ManageListingsPage: {
      loadData: ManageListingsPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    RequestQuotePage: {
      loadData: RequestQuotePageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
  };
};

export default getPageDataLoadingAPI;
